import { Alert, Heading, Image, Text, useAuthenticator, useTheme, View } from '@aws-amplify/ui-react';
import { RESET_REQUIRED_SIGN_IN_MESSAGE, resetRequiredSignInAlert } from 'auth/authenticatorServices';
import AlertMessageContent from 'components/feedback/AlertMessageContent';

import tratonLogo from '../assets/traton-logo.png';

import './_styles.scss';

const SignInFooter = () => {
    const { error } = useAuthenticator(context => [context.error]);

    if (error !== RESET_REQUIRED_SIGN_IN_MESSAGE) {
        return null;
    }

    return (
        <Alert className='AuthComponents__resetRequiredAlert' variation='error' role='alert'>
            <AlertMessageContent message={resetRequiredSignInAlert} />
        </Alert>
    );
};

export const components = {
    Header: () => {
        const { tokens } = useTheme();
        return (
            <View textAlign='center' padding={tokens.space.large}>
                <Image width='400' height='auto' alt='Traton logo' src={tratonLogo} />
            </View>
        );
    },
    Footer: () => {
        const { tokens } = useTheme();
        return (
            <View textAlign='center' padding={tokens.space.large}>
                <Text color={tokens.colors.neutral[80]}>&copy; All Rights Reserved</Text>
            </View>
        );
    },

    SignIn: {
        Header: () => {
            const { tokens } = useTheme();

            return (
                <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
                    Sign in to your account
                </Heading>
            );
        },
        Footer: SignInFooter,
    },
};

export const formFields = {
    signIn: {
        username: {
            placeholder: 'Enter your email',
        },
    },
    forceNewPassword: {
        password: {
            placeholder: 'Enter your Password',
        },
    },
};
